import Vue from 'vue';

Vue.filter('niceTime', isoTimeString =>
(new Date(isoTimeString)).toLocaleString('de-DE'),
);



// WEBPACK FOOTER //
// ./filters/nice-time.js